export default {
  GET_WEBHOOKS_REQUEST: 'WebhooksConstants.GET_WEBHOOKS_REQUEST',
  GET_WEBHOOKS_SUCCESS: 'WebhooksConstants.GET_WEBHOOKS_SUCCESS',
  GET_WEBHOOKS_FAILURE: 'WebhooksConstants.GET_WEBHOOKS_FAILURE',
  DELETE_WEBHOOKS_REQUEST: 'WebhooksConstants.DELETE_WEBHOOKS_REQUEST',
  DELETE_WEBHOOKS_SUCCESS: 'WebhooksConstants.DELETE_WEBHOOKS_SUCCESS',
  DELETE_WEBHOOKS_FAILURE: 'WebhooksConstants.DELETE_WEBHOOKS_FAILURE',
};
